var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M1 8h14M8 1l7 7-7 7"})));
}

ArrowRight.defaultProps = {"width":"16","height":"16"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
